export const AJAX_IDLE = 'AJAX_IDLE';
export const AJAX_PROCESSING = 'AJAX_PROCESSING';
export const AJAX_SUCCESS = 'AJAX_SUCCESS';
export const AJAX_FAIL = 'AJAX_FAIL';
